<template>
<div class="chapter">
<div class="inner_page">
<p class="pagehead"><b>Contents</b></p>
<p class="image0"><img alt="image" src="images/image1.jpg"/></p>
<p class="contents"><a href="#/listofplates">List of Plates</a><a id="plate"></a></p>
<p class="contents"><a href="#/maps">List of Maps</a><a id="map"></a></p>
<p class="contents"><a href="#/acknowledgements">Acknowledgements</a><a id="ack"></a></p>
<p class="contents"><a href="#/background">Background</a><a id="back"></a></p>
<p class="contents"><a href="#/chapter1">Campaign Chronicle</a><a id="chap1"></a></p>
<p class="contents1"><a href="#/chapter1#title-1">June 1940: The Italian Blitz</a><a id="title_1"></a></p>
<p class="contents1"><a href="#/chapter1#title-2">July 1940: The State of Maltese Morale</a><a id="title_2"></a></p>
<p class="contents1"><a href="#/chapter1#title-3">August-December 1940: Malta’s Strategic Role</a><a id="title_3"></a></p>
<p class="contents1"><a href="#/chapter1#title-4">January 1941: The German Blitz</a><a id="title_4"></a></p>
<p class="contents1"><a href="#/chapter1#title-5">February 1941: The Luftwaffe Ascendant</a><a id="title_5"></a></p>
<p class="contents1"><a href="#/chapter1#title-6">April 1941: Rationing Introduced</a><a id="title_6"></a></p>
<p class="contents1"><a href="#/chapter1#title-7">May 1941: Allied Reverses in the Mediterranean</a><a id="title_7"></a></p>
<p class="contents1"><a href="#/chapter1#title-8">June 1941: Malta Reinforced</a><a id="title_8"></a></p>
<p class="contents1"><a href="#/chapter1#title-9">July 1941: <i>Operazione C3</i></a><a id="title_9"></a></p>
<p class="contents1"><a href="#/chapter1#title-10">August 1941: Malta – the Key to the Mediterranean</a><a id="title_10"></a></p>
<p class="contents1"><a href="#/chapter1#title-11">September 1941: Fortunes of the Malta Convoys</a><a id="title_11"></a></p>
<p class="contents1"><a href="#/chapter1#title-12">November 1941: A Question of Morale</a><a id="title_12"></a></p>
<p class="contents1"><a href="#/chapter1#title-13">December 1941: The Kesselring Offensive</a><a id="title_13"></a></p>
<p class="contents1"><a href="#/chapter1#title-14">January 1942: The Air Battle Continues</a><a id="title_14"></a></p>
<p class="contents1"><a href="#/chapter1#title-15">February 1942: The Demand for Spitfires</a><a id="title_15"></a></p>
<p class="contents1"><a href="#/chapter1#title-16">March 1942: Running the Axis Blockade</a><a id="title_16"></a></p>
<p class="contents1"><a href="#/chapter1#title-17">April 1942: The German Onslaught</a><a id="title_17"></a></p>
<p class="contents1"><a href="#/chapter1#title-18">May 1942: Dobbie Replaced by Lord Gort</a><a id="title_18"></a></p>
<p class="contents1"><a href="#/chapter1#title-19">June 1942: Reduced Rations</a><a id="title_19"></a></p>
<p class="contents1"><a href="#/chapter1#title-20">July 1942: Allied Air Superiority Established</a><a id="title_20"></a></p>
<p class="contents1"><a href="#/chapter1#title-21">August 1942: Operation <i>Pedestal</i></a><a id="title_21"></a></p>
<p class="contents1"><a href="#/chapter1#title-22">October 1942: The Luftwaffe’s Last Offensive</a><a id="title_22"></a></p>
<p class="contents1"><a href="#/chapter1#title-23">November 1942: The Siege is Raised</a><a id="title_23"></a></p>
<p class="contents"><span href="#/after" title="Link target outside of Sample">Aftermath</span><a id="after"></a></p>
<p class="contents"><span href="#/appendix1" title="Link target outside of Sample">Appendices</span></p>
<p class="contents1"><span href="#/appendix1" title="Link target outside of Sample">The Siege of Malta in Seven Acts</span><a id="app1"></a></p>
<p class="contents1"><span href="#/appendix2" title="Link target outside of Sample">Naval Strength in the Mediterranean 1940</span><a id="app2"></a></p>
<p class="contents1"><span href="#/appendix3" title="Link target outside of Sample">The Malta Convoys</span><a id="app3"></a></p>
<p class="contents1"><span href="#/appendix4" title="Link target outside of Sample">The Composition of the Key Convoys, Their Naval Escorts, and the Axis Forces Operating Against Them, July 1941-August 1942</span><a id="app4"></a></p>
<p class="contents1"><span href="#/appendix5" title="Link target outside of Sample">Malta’s Air Defences</span><a id="app5"></a></p>
<p class="contents1"><span href="#/appendix6" title="Link target outside of Sample">Malta’s Land Defences</span><a id="app6"></a></p>
<p class="contents1"><span href="#/appendix7" title="Link target outside of Sample">An Interview with Godwin Castaldi by the Author on 12 September 2006</span><a id="app7"></a></p>
<p class="contents1"><span href="#/appendix8" title="Link target outside of Sample">Biographies of Key Figures</span><a id="app8"></a></p>
<p class="contents1"><span href="#/appendix9" title="Link target outside of Sample">Bibliography</span><a id="app9"></a></p>
<p class="contents1"><span href="#/appendix10" title="Link target outside of Sample">Glossary</span><a id="app10"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?5361ee95